import { render, staticRenderFns } from "./UserChangePhoneForm.vue?vue&type=template&id=29ef9268&scoped=true"
import script from "./UserChangePhoneForm.vue?vue&type=script&lang=js"
export * from "./UserChangePhoneForm.vue?vue&type=script&lang=js"
import style0 from "./UserChangePhoneForm.vue?vue&type=style&index=0&id=29ef9268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ef9268",
  null
  
)

export default component.exports